import { useState } from "react"
import { useUser } from "@/api/users"
import { Button } from "@/components/ui/button"
import { SendModal } from "./send.modal"
import ArrowDownIcon from "@/components/icons/arrow-down"
// KYC gating removed per new requirement – users always have a wallet after onboarding.

interface SendButtonProps {
  variant?: "default" | "outline";
}

export default function SendButton({ variant = "default" }: SendButtonProps) {
  const { user } = useUser()
  const [isOpen, setIsOpen] = useState(false)

  if (!user) return null

  const handleClick = () => setIsOpen(true)

  return (
    <>
      {user.hasWallet && <SendModal open={isOpen} onOpenChange={setIsOpen} />}
      <Button
        variant={variant}
        onClick={handleClick}
        data-testid="withdraw"
        disabled={!user.hasWallet}
        className="flex-grow"
      >
        <ArrowDownIcon direction="up" />
        Send
      </Button>
    </>
  )
}
